import React, { useState } from 'react';
import axios from 'axios';
import { Toaster } from 'react-hot-toast';
import toastTemplate from '../template/toastTemplate';

const ListProperty = ({ header, paraText }) => {

    const {successToast, failureToast, WaitingToast, notify} = toastTemplate

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phoneNumber: '',
        propertyAddress: '',
        message: '',
    });

    const [ready, setReady] = useState(false)

    const handleClick = (link) => {
        window.location.href = link;
    };
    
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (!!formData.name && !!formData.email && !!formData.phoneNumber) {
            setReady(true)
        } else {
            setReady(false)
        }
        
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };    

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Basic form validations
        if (!formData.name || !formData.email || !formData.phoneNumber) {
            alert('Please fill in all required fields.');
            return;
        }

        const waitId = WaitingToast()

        try {
            const response = await axios.post('https://7d4nmtpj4g.execute-api.us-east-1.amazonaws.com/first', formData, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            if (response.data.statusCode === 200) {
                successToast(waitId)
                await setTimeout(() => {
                    notify("We will contact you shortly", "🫰🏼")
                }, 2000)
                setFormData({
                    name: '',
                    email: '',
                    phoneNumber: '',
                    propertyAddress: '',
                    message: '',
                })
                setReady(false)
            } else {
                failureToast(waitId)
                setTimeout(() => {
                    notify("Please Try Again", "😓")
                }, 2500)
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    return (
        <>
            <div>
                <Toaster />
            </div>
            <div className='grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-16 w-full bg-colour px-4 sm:px-6 md:px-12 mid-lg:px-16 lg:px-24 pt-24 sm:pt-28 md:pt-36 pb-16 sm:pb-20'>
                <div className='lg:col-span-2 flex flex-col justify-between'>
                    <div>
                        <h1 className='tracking-widest font-thin md:font-light text-2xl sm:text-3xl md:text-4xl lg:text-5xl mb-4 md:mb-6 text-gray-900'>
                            {header ? `${header}` : 'LIST YOUR PROPERTY WITH HAIDERIES'}
                        </h1>
                        <p className='max-w-lg tracking-wide text-xs sm:text-sm md:text-base text-gray-600 leading-relaxed mb-6'>
                            {paraText ? `${paraText}` : 'Get the consultation in minutes! We are here to take care of your properties, to connect you with the right buyers. We have sold, rented, and managed thousands of mixed-used properties worth several billions of dirhams. Get in touch with us today.'}
                        </p>
                    </div>

                    <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4 pt-4 border-t border-gray-200'>
                        <div className='border-b pb-3'>
                            <h2 className='text-xs text-gray-500 font-semibold tracking-wider'>PHONE</h2>
                            <h3 className='text-sm sm:text-base font-medium my-1 cursor-pointer hover:text-bluColor transition-colors' onClick={() => handleClick('tel:+971542999975')}>+971 54 299 9975</h3>
                        </div>
                        <div className='border-b pb-3'>
                            <h2 className='text-xs text-gray-500 font-semibold tracking-wider'>WHATSAPP</h2>
                            <h3 className='text-sm sm:text-base font-medium my-1 cursor-pointer hover:text-green-600 transition-colors' onClick={() => handleClick('https://wa.me/+971502607861')}>Click to Open WhatsApp</h3>
                        </div>
                        <div className='border-b pb-3'>
                            <h2 className='text-xs text-gray-500 font-semibold tracking-wider'>EMAIL</h2>
                            <h3 className='text-sm sm:text-base font-medium my-1 cursor-pointer hover:text-bluColor transition-colors' onClick={() => handleClick('mailto:info@haideries.ae')}>info@haideries.ae</h3>
                        </div>
                        <div className='pb-3'>
                            <h2 className='text-xs text-gray-500 font-semibold tracking-wider'>OFFICE</h2>
                            <h3 className='text-sm sm:text-base font-medium my-1 text-gray-800'>Dubai, UAE</h3>
                        </div>
                    </div>
                </div>
                <div className='lg:col-span-3 w-full bg-white rounded-xl p-6 sm:p-8 md:p-10 shadow-lg border border-gray-100'>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-4 md:mb-8 lg:mb-12">
                            <label htmlFor="name" className="block text-xs font-semibold mb-2">
                                Name
                            </label>
                            <input
                                type="text"
                                id="name"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className="w-full p-2 border border-gray-300"
                                required
                            />
                        </div>
                        <div className="mb-4 md:mb-8 lg:mb-12">
                            <label htmlFor="email" className="block text-xs font-semibold mb-2">
                                Email Address
                            </label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="w-full p-2 border border-gray-300"
                                required
                            />
                        </div>
                        <div className="mb-4 md:mb-8 lg:mb-12">
                            <label htmlFor="phoneNumber" className="block text-xs font-semibold mb-2">
                                Phone Number
                            </label>
                            <input
                                type="number"
                                id="phoneNumber"
                                name="phoneNumber"
                                value={formData.phoneNumber}
                                onChange={handleChange}
                                className="w-full p-2 border border-gray-300"
                                required
                            />
                        </div>
                        <div className="mb-4 md:mb-8 lg:mb-12">
                            <label htmlFor="propertyAddress" className="block text-xs font-semibold mb-2">
                                Property Address <span className="font-bold">(Optional)</span>
                            </label>
                            <input
                                type="text"
                                id="propertyAddress"
                                name="propertyAddress"
                                value={formData.propertyAddress}
                                onChange={handleChange}
                                className="w-full p-2 border border-gray-300"
                            />
                        </div>
                        <div className="mb-4 md:mb-6 lg:mb-8">
                            <label htmlFor="message" className="block text-xs font-semibold mb-2">
                                Message <span className="font-bold">(Optional)</span>
                            </label>
                            <textarea
                                id="message"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                rows="4"
                                className="w-full p-2 border border-gray-300"
                            ></textarea>
                        </div>
                        <div className="flex justify-end">
                            <button type="submit" className={`bg-black tracking-widest text-white w-full py-4 text-xs ${ready ? '' : `bg-gray-600 cursor-no-drop`}`}>
                                SUBMIT DETAILS
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default ListProperty;
